import { render, staticRenderFns } from "./EchartsClassStatistics.vue?vue&type=template&id=3a044688&"
import script from "./EchartsClassStatistics.vue?vue&type=script&lang=js&"
export * from "./EchartsClassStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports